import React from 'react';
import {
  Card, Typography, Grid, Box,
} from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from '@gamiphy/react-i18n';
import { CirclesStore } from '@gamiphy/loyalty-station-desktop/store/circle';

interface Props {
  handleClose: React.Dispatch<React.SetStateAction<boolean>>;
}

const InviteeList: React.FC<Props> = ({ handleClose }) => {
  const { t } = useTranslation();
  const { circles } = CirclesStore;

  return (
    <Card sx={{ width: '100%', borderRadius: 0 }}>
      <Grid
        container
        direction="column"
        alignItems="center"
        spacing={2}
      >
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={(theme) => ({
            fontSize: '1.2rem',
            fontWeight: 500,
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.text.secondary,
            textAlign: 'left',
            width: '100%',
            p: 3,
            pt: 3,
            pb: 1,
            mb: 1,
          })}
        >
          <Grid>
            {t('inviteFriend.invitee.list', { defaultValue: 'Your invitees list' })}
          </Grid>
          <Grid size={1} sx={{ cursor: 'pointer' }} onClick={() => handleClose(false)}>
            <CloseIcon fontSize="large" />
          </Grid>
        </Grid>

        <Box
          sx={(theme) => ({
            overflowY: 'scroll',
            width: '95%',
            height: '18rem',
            margin: '0 auto',
            textAlign: 'left',
            p: 1,
            '&::-webkit-scrollbar': {
              width: '4px',
              background: 'transparent',
            },
            '&::-webkit-scrollbar-track': {
              margin: theme.spacing(1),
            },
            '&::-webkit-scrollbar-thumb': {
              background: '#0000001e',
              borderRadius: '10px',
            },
          })}
        >
          {circles?.map(({ follower, id }) => (
            <Grid
              key={id}
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={0}
              sx={{
                width: '100%',
                backgroundColor: '#F9F9F9',
                border: '1px solid #E5E5E5',
                borderRadius: 6,
                p: 0.5,
                mb: 1.5,
              }}
            >
              <AccountCircleIcon color="primary" fontSize="large" />
              <Grid size={11}>
                <Typography sx={{
                  fontSize: '1.2rem',
                  color: '#677683',
                  textAlign: 'left',
                  wordWrap: 'break-word',
                  overflowWrap: 'break-word',
                  maxWidth: '26rem',
                  ml: 1,
                }}
                >
                  {follower?.email}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Box>
      </Grid>
    </Card>
  );
};

export default InviteeList;
